var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-main-content voucher-maintenance" },
    [
      _c("div", { staticClass: "tabs-container" }, [
        _c("div", { staticClass: "grid-view" }, [
          _c(
            "div",
            { staticClass: "main-content voucher-list" },
            [
              _c(
                "search-item",
                {
                  attrs: {
                    "config-module": "1900",
                    reset: true,
                    "custom-sim-query-placeholder": _vm.$t(
                      "SystemMaintenance.QuickSearchAdTheme"
                    )
                  },
                  on: {
                    "click-more": function(value) {
                      return (_vm.isAdvancedQuery = value)
                    },
                    simSearchItemCallBack: _vm.toSimpleQuery,
                    advSearchItemCallBack: _vm.toAdvancedQuery
                  }
                },
                [
                  _c("div", {
                    staticClass: "triggers",
                    attrs: { slot: "operations" },
                    slot: "operations"
                  })
                ]
              ),
              _c(
                "div",
                { staticClass: "section grid-wrapper" },
                [
                  _c("cargo-ag-grid", {
                    attrs: {
                      "grid-params": _vm.gridParams,
                      "grid-options": _vm.gridOptions,
                      "column-defs": _vm.columnDefs,
                      "row-data": _vm.rowData
                    },
                    on: {
                      "update:gridParams": function($event) {
                        _vm.gridParams = $event
                      },
                      "update:grid-params": function($event) {
                        _vm.gridParams = $event
                      },
                      gridReady: _vm.onReady
                    }
                  })
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "pagination-wrapper" },
                [
                  _c("cargo-pagination", {
                    attrs: {
                      "page-count": _vm.filter.pageCount,
                      total: _vm.filter.total,
                      page: _vm.filter.pageNum,
                      limit: _vm.filter.pageSize
                    },
                    on: {
                      "update:page": function($event) {
                        return _vm.$set(_vm.filter, "pageNum", $event)
                      },
                      "update:limit": function($event) {
                        return _vm.$set(_vm.filter, "pageSize", $event)
                      },
                      pagination: _vm.toQueryByPage
                    }
                  })
                ],
                1
              )
            ],
            1
          )
        ])
      ]),
      _c("click-user-window", {
        attrs: {
          params: _vm.clickUserWindow.params,
          visible: _vm.clickUserWindow.visible
        },
        on: { cancelVisible: _vm.cancelVisibleHandler }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }